import { urlReplace } from "helpers/url";
import Api from "./Api";

export default class TenderService {
	constructor(api) {
		this.api = api || new Api();
	}

	async getAll(params) {
		return this.api.get('/secure/tenders', params);
	}

	async getById(id, params) {
		return this.api.get(urlReplace('/secure/tender/{id}', { id: id }), params);
	}
}
